<div class="page-visualizer-client">
  <div class="visualizer-shell">
    <div class="visualizer-canvas">
      <div class="visualizer-header" *ngIf="details() as detail">
        <div class="header-actions-container">
          <div class="action-controls">
            <!-- <button mat-icon-button (click)="downloadCsv()" matTooltip="Descargar detecciones en CSV">
              <mat-icon class="material-symbols-outlined">download</mat-icon>
            </button> -->
            <button mat-icon-button (click)="onShared()" aria-label="Más información">
              <mat-icon class="material-symbols-outlined">share</mat-icon>
            </button>
            <button [matMenuTriggerFor]="menu" mat-icon-button>
              <mat-icon class="material-symbols-outlined">info</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <div class="info-recon">
                <span>Id reconocimiento</span>
                <div class="info-id">
                  <p>{{ detail.recognition_id }}</p>
                  <button mat-icon-button (click)="copyIdRecon(detail.recognition_id)">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </div>
                <div class="timer">
                  <mat-icon>timer</mat-icon>
                  <span>
                    {{ calculateDurationInSeconds(detail.started_at, detail.finished_at) }} segundos
                  </span>
                </div>
                <div class="info-dates">
                  <div class="info-dates-cont">
                    <span>Inició</span>
                    <span>{{ detail.started_at | date:'hh:mm:ss.SSS a':'UTC' }}</span>
                    <span>{{ detail.started_at | date:'yyyy-MM-dd':'UTC' }}</span>
                  </div>
                  <div class="info-dates-cont">
                    <span>Finalizó</span>
                    <span>{{ detail.finished_at | date:'hh:mm:ss.SSS a':'UTC' }}</span>
                    <span>{{ detail.finished_at | date:'yyyy-MM-dd':'UTC' }}</span>
                  </div>
                </div>
              </div>
            </mat-menu>
          </div>
          <div class="zoom-controls">
            <button mat-icon-button type="button" (click)="zoomOut()" [disabled]="zoomLevel() <= minZoom"
              aria-label="Alejar">
              <mat-icon class="material-symbols-outlined">zoom_out</mat-icon>
            </button>
            <button mat-button type="button" class="zoom-value" (click)="resetZoom()" aria-label="Restablecer zoom">
              {{ (zoomLevel() * 100) | number:'1.0-0' }}%
            </button>
            <button mat-icon-button type="button" (click)="zoomIn()" [disabled]="zoomLevel() >= maxZoom"
              aria-label="Acercar">
              <mat-icon class="material-symbols-outlined">zoom_in</mat-icon>
            </button>
            @if (isDialogMode) {
              <button mat-icon-button type="button" (click)="closeRequest.emit()" aria-label="Cerrar" matTooltip="Cerrar">
                <mat-icon>close</mat-icon>
              </button>
            }
          </div>
        </div>
      </div>
      <app-image-visualizer *ngIf="imageSrc(); else emptyState" [imageSrc]="imageSrc()" [boxes]="boxes()"
        [fitMode]="'contain'" [imageSize]="imageSize() ?? undefined" [coordinateSpace]="coordinateSpace"
        [selectedBoxId]="selectedBoxId()" (boxClick)="onBoxClick($event)" (boxHover)="onBoxHover($event)"
        (boxDismiss)="selectedBoxId.set(null)" [showZoomControls]="false" [zoom]="zoomLevel()" [minZoom]="minZoom"
        [maxZoom]="maxZoom" [zoomStep]="zoomStep" (zoomChange)="onZoomChange($event)"
        [showInfoCard]="false" [showBoxTooltip]="false"
        (imageLoaded)="onImageLoadedFromVisualizer($event)"></app-image-visualizer>

      <div class="loading-overlay" *ngIf="isLoading()">
        <mat-progress-spinner
          *ngIf="loadingState() !== 'timeout'"
          diameter="36"
          strokeWidth="3"
          mode="indeterminate"
        ></mat-progress-spinner>
        <span class="loading-text">{{ loadingMessage() }}</span>
      </div>

      <div class="image-controls" *ngIf="images().length > 1">
        <button class="nav-btn" type="button" (click)="prevImage()" [disabled]="selectedIndex() === 0">
          ‹
        </button>
        <div class="thumbs">
          <button class="thumb" *ngFor="let img of images(); let i = index; trackBy: trackByImage"
            [class.is-active]="i === selectedIndex()" type="button" (click)="selectImageByIndex(i)">
            <img [src]="img.url" [alt]="img.file_name || 'imagen'" loading="lazy" />
          </button>
        </div>
        <button class="nav-btn" type="button" (click)="nextImage()"
          [disabled]="selectedIndex() === images().length - 1">
          ›
        </button>
      </div>
    </div>

    <aside class="visualizer-panel">
      <div class="panel-loading-overlay" *ngIf="isLoading()">
        <mat-progress-spinner
          *ngIf="loadingState() !== 'timeout'"
          diameter="30"
          strokeWidth="3"
          mode="indeterminate"
        ></mat-progress-spinner>
        <span class="loading-text">Preparando datos...</span>
      </div>
      <ng-container *ngIf="!isLoading()">
        <app-metadata-card class="metadata-card-slot" [data]="details()?.client_metadata ?? null"
          [fields]="fields_metadata"></app-metadata-card>
        <mat-tab-group>
          <mat-tab label="Mediciones">
            <div class="tab-body">
              <app-measurements-panel [rules]="rules()" [veredict]="details()?.veredict ?? null"></app-measurements-panel>
            </div>
          </mat-tab>
          <!-- <mat-tab label="Detecciones">
            <div class="tab-body">
              <app-detections-panel [inferences]="details()?.inferences ?? []" (boxSelect)="selectedBoxId.set($event)"
                (boxToggle)="onBoxToggle($event)"></app-detections-panel>
            </div>
          </mat-tab> -->
        </mat-tab-group>
      </ng-container>
    </aside>
  </div>

  <ng-template #emptyState>
    <div class="empty-state">
      Sin imagen para visualizar.
    </div>
  </ng-template>
</div>
